import React from 'react'
import {
  Table as MuiTable,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Paper,
  Box,
  Typography,
} from '@mui/material'
import ErrorMessage from '../../component/shared/component/ErrorMessage'
import { useGetSalesCommissions } from '../../api/sales-commission'
import Row from './Row'
import { LoadingSkeletonRows } from '../shared/LoadingSkeletonRows'
import Import from './Import'

const Table = ({ monthYear, open, setOpen }) => {
  const { data = {}, isLoading, refetch } = useGetSalesCommissions({ monthYear })

  return (
    <Box>
      {Object.keys(data).length || isLoading ? (
        <>
          <TableContainer component={Paper}>
            <MuiTable>
              <TableHead>
                <TableRow>
                  <TableCell>Sales Id</TableCell>
                  <TableCell>Payment</TableCell>
                  <TableCell>Commission</TableCell>
                  <TableCell />
                  <TableCell />
                </TableRow>
              </TableHead>
              <TableBody>
                {isLoading ? (
                  <LoadingSkeletonRows rows={10} length={5} />
                ) : (
                  Object.entries(data).map(([company, records]) => (
                    <React.Fragment key={company}>
                      <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                        <TableCell colSpan={5}>
                          <Typography variant='subtitle1' fontWeight='bold' textAlign={'center'}>
                            {company}
                          </Typography>
                        </TableCell>
                      </TableRow>
                      {records.map((row) => (
                        <Row data={row} key={row._id} refetch={refetch} />
                      ))}
                    </React.Fragment>
                  ))
                )}
              </TableBody>
            </MuiTable>
          </TableContainer>
        </>
      ) : (
        <ErrorMessage empty />
      )}
      <Import open={open} setOpen={setOpen} refetch={refetch} />
    </Box>
  )
}

export default Table
